import React, { useEffect, useRef, useState } from 'react';
import { FaBell, FaUserCircle, FaChevronDown, FaSignOutAlt, FaPlus } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import { FiEdit3 } from 'react-icons/fi';
import { MdOutlineArrowOutward } from 'react-icons/md';
import { IoPerson } from "react-icons/io5";
import { MdOutlineMailOutline } from "react-icons/md";

const StudentInfoApplication = () => {
  // Dropdown state & refs
  const [showNotifications, setShowNotifications] = useState(false);
  const [showProfileMenu, setShowProfileMenu] = useState(false);
  const notificationRef = useRef(null);
  const profileRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (notificationRef.current && !notificationRef.current.contains(e.target)) {
        setShowNotifications(false);
      }
      if (profileRef.current && !profileRef.current.contains(e.target)) {
        setShowProfileMenu(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  // Hard-coded pagination settings
  const itemsPerPage = 3;
  const totalPages = 2;
  const [currentPage, setCurrentPage] = useState(1);

  // Application data with status management
  const [applications, setApplications] = useState([
    { 
      id: 1, 
      applicant: 'David | Washington, UK', 
      country: 'United Kingdom' ,
      institution: 'Ashton University', 
      course: 'Masters of Science in Nursing (Feb 2016)', 
      addedOn: '06/18/2005', 
      lastUpdated: '06/18/2005', 
      status: 'Active' 
    },
    { 
      id: 2, 
      applicant: 'Sarah | London, UK', 
       country: 'United Kingdom' ,
      institution: 'Cambridge University', 
      course: 'Bachelor of Arts in Literature (Sep 2017)', 
      addedOn: '05/10/2006', 
      lastUpdated: '05/11/2006', 
      status: 'Blocked' 
    },
    { 
      id: 3, 
      applicant: 'Mark | Manchester, UK', 
       country: 'United Kingdom' ,
      institution: 'Oxford University', 
      course: 'PhD in Computer Science (Jan 2018)', 
      addedOn: '04/01/2007', 
      lastUpdated: '04/02/2007', 
      status: 'De-active' 
    },
    { 
      id: 4, 
      applicant: 'Alice | Edinburgh, UK', 
       country: 'United Kingdom' ,
      institution: 'Edinburgh University', 
      course: 'Masters in Business Administration (Mar 2019)', 
      addedOn: '03/15/2008', 
      lastUpdated: '03/16/2008', 
      status: 'Active' 
    },
    { 
      id: 5, 
      applicant: 'Bob | Glasgow, UK', 
       country: 'United Kingdom' ,
      institution: 'Glasgow University', 
      course: 'Bachelor of Science in Physics (Oct 2020)', 
      addedOn: '02/20/2009', 
      lastUpdated: '02/21/2009', 
      status: 'Pending' 
    },
    { 
      id: 6, 
      applicant: 'Emma | Bristol, UK',
       country: 'United Kingdom' , 
      institution: 'Bristol University', 
      course: 'Masters in Law (Jul 2021)', 
      addedOn: '01/05/2010', 
      lastUpdated: '01/06/2010', 
      status: 'Active' 
    },
  ]);

  // Toggle application status
  const toggleApplicationStatus = (id) => {
    setApplications(prev => prev.map(app => 
      app.id === id 
        ? { 
            ...app, 
            status: app.status === 'Active' ? 'De-active' : 'Active' 
          } 
        : app
    ));
  };

  // Status badge helper with null check
  const getStatusClass = (status) => {
    if (!status) return 'status-badge'; // Handle undefined/null status
    
    const statusLower = status.toLowerCase();
    switch (statusLower) {
      case 'active': return 'status-badge active';
      case 'blocked': return 'status-badge blocked';
      case 'de-active': return 'status-badge de-active';
      case 'pending': return 'status-badge pending';
      default: return 'status-badge';
    }
  };

  return (
    <div className="container dashboard">
      {/* Top bar */}
      <div className="container ">
        <div className="row">
          <div className="d-flex flex-row align-items-center justify-content-end">
            {/* Notification Dropdown */}
            <div className="position-relative me-3" ref={notificationRef}>
              <button 
                className="btn btn-link text-decoration-none p-2 bg-white rounded-3 shadow-sm d-flex align-items-center"
                onClick={() => setShowNotifications(!showNotifications)}
              >
                <FaBell className="fs-4 text-muted" />
                <span className="position-absolute text-danger top-0 start-100 translate-middle badge rounded-pill bg-danger">
                    .
                  </span>
              </button>
              
              {/* Notification Dropdown Menu */}
              {showNotifications && (
                 <div className="dropdown-menu show notificationadmin shadow-lg p-0">
                 <div className="p-3 border-bottom">
                   <h6 className="fw-bold mb-0">Notifications</h6>
                 </div>
                 <div className="overflow-auto" style={{ maxHeight: '300px' }}>
                   <a href="#" className="dropdown-item d-flex py-3 border-bottom">
                     <div className='text-start'>
                       <p className="mb-0 fw-medium">New message received</p>
                       <small className="text-muted">You have 2 unread messages</small>
                       <div className="text-muted small mt-1">2 hours ago</div>
                     </div>
                   </a>
                   <a href="#" className="dropdown-item d-flex py-3 border-bottom">
                     <div className='text-start'>
                       <p className="mb-0 fw-medium">Meeting reminder</p>
                       <small className="text-muted">Team meeting at 3:00 PM</small>
                       <div className="text-muted small mt-1">5 hours ago</div>
                     </div>
                   </a>
                   <a href="#" className="dropdown-item d-flex py-3">
                     <div className='text-start'>
                       <p className="mb-0 fw-medium">System update</p>
                       <small className="text-muted">Maintenance scheduled for tomorrow</small>
                       <div className="text-muted small mt-1">Yesterday</div>
                     </div>
                   </a>
                   {/* Additional items to show scrollbar */}
                   <a href="#" className="dropdown-item d-flex py-3 border-top">
                     <div className='text-start'>
                       <p className="mb-0 fw-medium">New feature available</p>
                       <small className="text-muted">Check out the latest updates</small>
                       <div className="text-muted small mt-1">2 days ago</div>
                     </div>
                   </a>
                   <a href="#" className="dropdown-item d-flex py-3">
                     <div className='text-start'>
                       <p className="mb-0 fw-medium">Document approved</p>
                       <small className="text-muted">Your submission has been approved</small>
                       <div className="text-muted small mt-1">3 days ago</div>
                     </div>
                   </a>
                 </div>
                 <div className="text-center py-2 border-top">
                   <a href="#" className="text-primary text-decoration-none small">View all notifications</a>
                 </div>
               </div>
              )}
            </div>
            
            {/* User Profile Dropdown */}
            <div className="position-relative" ref={profileRef}>
              <button 
                className="btn btn-link text-decoration-none p-2 bg-white rounded-3 shadow-sm d-flex align-items-center"
                onClick={() => setShowProfileMenu(!showProfileMenu)}
              >
                <div className="d-flex flex-column align-items-end me-2">
                  <span className="fw-bold text-dark">derek aivarado</span>
                  <span className="small text-muted">Admin</span>
                </div>
                <div className="position-relative">
                  <div className="bg-light border rounded-circle p-1">
                    <FaUserCircle className="fs-1 text-primary" />
                  </div>
                  <FaChevronDown className="text-muted small position-absolute bottom-0 end-0 bg-white rounded-circle p-1 border" style={{ fontSize: '0.6rem' }} />
                </div>
              </button>
              
              {/* Profile Dropdown Menu */}
              {showProfileMenu && (
                <div className="dropdown-menu show shadow-lg" style={{ width: '220px', right: 0, left: 'auto', display: 'block' }}>
                  <div className="text-center p-3 border-bottom">
                    <FaUserCircle className="fs-1 text-primary mb-2" />
                    <h6 className="mb-0 fw-bold">derek aivarado</h6>
                    <small className="text-muted">RY Admin</small>
                  </div>
                  <a href="#" className="dropdown-item d-flex align-items-center py-2">
                    <FaUserCircle className="me-3 text-muted" />
                    <span>My Profile</span>
                  </a>
                
                  <div className="dropdown-divider my-1"></div>
                  <a href="#" className="dropdown-item d-flex align-items-center py-2 text-danger">
                    <FaSignOutAlt className="me-3" />
                    <span>Logout</span>
                  </a>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* Header & Breadcrumb */}
      <h2 className="fw-bold mb-1">Applications</h2>
      <div className="small mb-4">
        <Link to="/student-info/dashboard" className="text-decoration-none text-dark">DASHBOARD</Link> / <span className="fw-bold">APPLICATIONS</span>
      </div>

      {/* Filters */}
      <div className="row  mb-4">
       <div className="row align-items-center g-2 mb-4 filters">
        <div className="col-auto">
          <Link to={'/student-info/add'} className="btn btn-outline-primary">
            <FaPlus className="me-1"/> NEW APPLICATION 
          </Link>
        </div>
        {['Institute','Last Updated','Reference No','Course','Status','Country','Search']
          .map((ph, i) => (
            <div className={`col-md-2 col-sm-4 col-6`} key={i}>
              {ph === 'Status' ? (
                <select className="form-select">
                  <option disabled selected>Status</option>
                  <option>Active</option>
                  <option>Blocked</option>
                  <option>Pending</option>
                </select>
              ) : (
                <input
                  type="text"
                  className="form-control"
                  placeholder={ph}
                />
              )}
            </div>
          ))
        }
      </div>
      </div>

      {/* Table */}
      <div className="table-wrapper">
        <table className="table">
          <thead>
            <tr>
              <th>#</th>
              <th>Country</th>
              <th>Institution & Courses</th>
              <th>Add Date</th>
              <th>Last Login</th>
              <th>Status</th>
              <th>Action</th>
            </tr>
          </thead>

          <tbody>
            {applications
              .filter((_, index) => 
                (currentPage === 1 && index < itemsPerPage) || 
                (currentPage === 2 && index >= itemsPerPage)
              )
              .map(app => (
                <tr key={app.id}>
                  <td>{app.id}</td>
                  <td>
                     {app.country}                   
                  </td>
                  <td>
                    <div className="fw-bold">{app.institution}</div>
                    <div className="small text-muted">{app.course}</div>
                  </td>
                  <td>{app.addedOn}</td>
                  <td>{app.lastUpdated}</td>
                  <td>
                    <div className="d-flex align-items-center">
                      <span className={`ms-2 ${getStatusClass(app.status)}`}>
                        {app.status || 'N/A'}
                      </span>
                    </div>
                  </td>
                  <td className="d-flex gap-2">
                    <button className="btn btn-sm btn-light"><MdOutlineArrowOutward /></button>
                    <button className="btn btn-sm btn-light"><FiEdit3 /></button>
                  </td>
                </tr>
              ))}
          </tbody>
        </table>

        {/* Pagination */}
        <div className="pagination mt-3">
          {[...Array(totalPages)].map((_, idx) => (
            <button
              key={idx}
              className={`page-button ${currentPage === idx + 1 ? 'active' : ''}`}
              onClick={() => setCurrentPage(idx + 1)}
            >
              {idx + 1}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default StudentInfoApplication;